module.exports = __webpack_public_path__ + "static/img/banner3.cfada8e6.jpg";